import React, { useState } from "react";
import { Button } from "@mui/material";
import styles from "./FileUpload.module.css";

interface FileUploadProps {
  onFileSelect?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileUploadComponent: React.FC<FileUploadProps> = ({ onFileSelect }) => {
  const [fileName, setFileName] = useState("Nenhum arquivo selecionado");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length) {
      const selectedFileName = event.target.files[0].name;
      setFileName(selectedFileName);
      if (onFileSelect) {
        onFileSelect(event);
      }
    } else {
      setFileName("Nenhum arquivo selecionado");
    }
  };

  return (
    <div className={styles.container}>
      <input
        id="file-upload"
        type="file"
        accept=".txt,.csv"
        onChange={handleFileChange}
        data-testid="file-upload"
        style={{ opacity: 0, position: "absolute", width: 0, height: 0 }}
      />
      <label htmlFor="file-upload" className={styles.label}>
        <Button variant="contained" component="span">
          Escolher Arquivo (TXT ou CSV)
        </Button>
      </label>
      <span className={styles.fileName} data-testid="file-name" role="status">
        {fileName}
      </span>
    </div>
  );
};

export default FileUploadComponent;
